export class HorseBreeder {
    id: number;
    name: string;
    emailAddress: string;
    phone: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    country: string;
}



// WEBPACK FOOTER //
// ./src/model/horseBreeder.ts